export default __webpack_public_path__ + "static/media/portfolio-82.c9c4360d.jpg";